var url = ''
if (window.location.host === 'arkan-stg-qr.nuviotech.co') {
  url = 'https://arkan-stg-api.nuviotech.co'
} else {
  url = 'http://localhost:3800'
}
export const URL_BASE = url



// WEBPACK FOOTER //
// ./src/helper/constants.js